import { gettext, t } from 'ttag';

import NDVI from '../../../media/ndvi.png';
import BSI from '../../../media/bsi.png';
import RE from '../../../media/re.png';
import NDMI from '../../../media/ndmi.png';

import NDVI_LEGEND from '../../../media/ndvi-legend.png';
import RE_LEGEND from '../../../media/re-legend.png';
import NDMI_LEGEND from '../../../media/ndmi-legend.png';

const PERFORMANCE_INDEX_COLORS = {
  black: `#000000`,
  red: `#f94144`,
  lightGreen: `#90be6d`,
  darkGreen: `#2C663C`,
  yellow: `#F9C74F`,
  yellowGreenMix: `#D4E991`,
  lightYellow: `#EDEB68`,
  brown: `#A55927`,
  lightGrey: `#B3AFC0`,
  white: `#ffffff`,
  lightBlue: `#86C8FE`,
  darkBlue: `#0021DC`,
  orange: `#EE6A2C`,
};

export const PERFORMANCE_INDEX_LAYERS = [
  {
    name: () => t`Field Vegetation`,
    id: `NDVI`,
    signalId: `CL_SIGNAL_TYPE.S2L1C_NDVI`,
    previewImage: NDVI,
    legendImage: NDVI_LEGEND,
    description: {
      text: () =>
        t`The Normalized Difference Vegetation Index (NDVI) is an indicator used for live green vegetation monitoring. The index quantifies vegetation photosynthetic capacity or plant greenness therefore a high index value indicates healthy vegetation with high vigour. The values can be used to detect presence of crops and measure crop vigour during the growing session.`,
      values: [
        {
          name: () => t`Water`,
          range: () => `-1 ${gettext('to')} -0.1`,
          hexColor: PERFORMANCE_INDEX_COLORS.black,
        },
        {
          name: () => t`Bare soil`,
          range: () => `-0.1 ${gettext('to')} 0.1`,
          hexColor: PERFORMANCE_INDEX_COLORS.red,
        },
        {
          name: () => t`Sparse vegetation`,
          range: () => `0.1 ${gettext('to')} 0.5`,
          hexColor: PERFORMANCE_INDEX_COLORS.lightGreen,
        },
        {
          name: () => t`Dense green vegetation`,
          range: () => `0.5 ${gettext('to')} 1.0`,
          hexColor: PERFORMANCE_INDEX_COLORS.darkGreen,
        },
      ],
    },
  },
  {
    name: () => t`Bare Soil Content`,
    id: `BSI`,
    signalId: 'CL_SIGNAL_TYPE.S2L1C_BSI',
    previewImage: BSI,
    legendImage: null,
    description: {
      title: ``,
      text: () =>
        t`The Bare Soil Index (BSI) facilitates the identification of bare soil and fallow land. Values above 0 indicate presence of exposed bare soil which can be linked to a tillage event, or a harvested field covered with non-photosynthetic vegetation or a field with dried up vegetation.     `,
      values: [
        {
          name: () => t`Dense vegetation`,
          range: () => `-1 ${gettext('to')} -0.6`,
          hexColor: PERFORMANCE_INDEX_COLORS.darkGreen,
        },
        {
          name: () => t`Sparse vegetation`,
          range: () => `-0.3 ${gettext('to')} 0`,
          hexColor: PERFORMANCE_INDEX_COLORS.yellowGreenMix,
        },
        {
          name: () => t`Bare soil`,
          range: () => `0 ${gettext('to')} 0.4`,
          hexColor: PERFORMANCE_INDEX_COLORS.brown,
        },
      ],
    },
  },
  {
    name: () => t`Chlorophyll Content`,
    id: `RE`,
    signalId: 'CL_SIGNAL_TYPE.S2L1C_RE',
    previewImage: RE,
    legendImage: RE_LEGEND,
    description: {
      title: `Chlorophyll Content`,
      text: () =>
        t`The Red Edge (RE) is an index that is related to the chlorophyll content in plants. This indicator measures the ratio of the red-edge light signals which are sensitive to changes of chlorophyll in the canopy of crops. In addition to detecting mature crops, it can also be used to estimate the efficiency of nitrogen uptake in the field. `,
      values: [
        {
          name: () => t`Dense vegetation`,
          range: () => `0 ${gettext('to')} 0.2`,
          hexColor: PERFORMANCE_INDEX_COLORS.darkGreen,
        },
        {
          name: () => t`Sparse vegetation`,
          range: () => `0.2 ${gettext('to')} 0.7`,
          hexColor: PERFORMANCE_INDEX_COLORS.lightGreen,
        },
        {
          name: () => t`Bare Soil`,
          range: () => `0.7 ${gettext('to')} 1`,
          hexColor: PERFORMANCE_INDEX_COLORS.lightYellow,
        },
        {
          name: () => t`Water`,
          range: () => `0.7 ${gettext('to')} 5`,
          hexColor: PERFORMANCE_INDEX_COLORS.lightGrey,
        },
      ],
    },
  },

  {
    name: () => t`Moisture Content`,
    id: `NDMI`,
    signalId: 'CL_SIGNAL_TYPE.S2L1C_NDMI',
    previewImage: NDMI,
    legendImage: NDMI_LEGEND,
    description: {
      title: ``,
      text: () =>
        t`The Normalized Difference Moisture Index (NDMI) is used to monitor changes in water content of leaves. The values can be interpreted to identify water stress problem areas in the field. `,
      values: [
        {
          name: () => t`Bare soil`,
          range: () => `-1 ${gettext('to')}  0`,
          hexColor: PERFORMANCE_INDEX_COLORS.orange,
        },
        {
          name: () => t`Possbile water stress`,
          range: () => `0 ${gettext('to')} 0.2`,
          hexColor: PERFORMANCE_INDEX_COLORS.lightBlue,
        },
        {
          name: () => t`No water stress`,
          range: () => `0.2 ${gettext('to')} 1`,
          hexColor: PERFORMANCE_INDEX_COLORS.darkBlue,
        },
      ],
    },
  },
];

export const TRUE_COLOR_BASE_LAYER = {
  name: () => t`True color`,
  id: `1-TRUE-COLOR`,
};
